import service from "@/api/http";
/* 
人文景点类型：
文化遗址：WENHUAYIZHI
文物保护单位：WENBAODANWEI
非物质文化遗产：FEIYI
AAAAA风景区：5AJINGQU
历史文化名城：MINGCHENG
历史文化名镇：MINGZHEN
历史文化名村：MINGCUN

图文信息类：
文化名人：WENHUAMINGREN
招商项目：ZHAONGSHANG
特色产业：CHANYE
红色旅游：HONGSE
生态旅游：SHENGTAI
文化旅游：WENHUA
寻味赣鄱：XUNWEI
产业规划：CHANYEGUIHUA
成功案例：CEHNGGONGANLI

附件资料类：
文化名人：WENHUAMINGREN
宣传片：XUANCHUANPIAN 
*/

export const bigdata = {
  /**
   * 图文信息列表
   * @param {Object} params.
   * @param {String} params.code 行政区划编码
   * @param {String} params.dataTypeCode 图文数据类型 ： 字典类型：PictureTextType
   */
  getNewsListByCode: (params) =>
    service.post("/api/bigData/getNewsListByCode", params),

  /**
   * 人文景点列表
   * @param {Object} params.
   * @param {String} params.code 行政区划编码
   * @param {String} params.dataTypeCode 人文景点类型 ： 字典类型：SightTypeDict
   * @param {String} params.isHot 是否热门
   */
  getSightListByCode: (params) =>
    service.post("/api/bigData/getSightListByCode", params),

  /**
   * 图文信息详情
   * @param {Number} id
   */
  getNewsDetail: (id) => service.post("/api/bigData/getNewsDetail", { id }),

  /**
   * 人文景点详情
   * @param {Number} id
   */
  getSightDetail: (id) => service.post("/api/bigData/getSightDetail", { id }),

  /**
   * 获取行政区域基本信息
   * @param {String} 行政区划编码
   */
  getBaseInfo: (code) => service.post("/api/bigData/getBaseInfo", { code }),

  /**
   * 获取行政地区人文风景数据数量
   * @param {Object} params.
   * @param {String} params.code 行政区划编码
   * @param {String} params.dataTypeCode 人文景点类型 ： 字典类型：SightTypeDict
   */
  getSighCount: (params) => service.post("/api/bigData/getSighCount", params),

  /**
   * 获取行政地区领导人列表
   * @param {String} code 行政区划编码
   */
  getLeaderList: (code) => service.post("/api/bigData/getLeaderList", { code }),

  /**
   * 获取行政地区附件资料
   * @param {Object} params.
   * @param {String} params.code 行政区划编码
   * @param {String} params.dataTypeCode 附件类型 ： 字典类型：AttachmentType
   */
  getAttachmentList: (params) =>
    service.post("/api/bigData/getAttachmentList", params),

  /**
   * 获取行政地区旅游人次
   * @param {String} code 行政区划编码
   */
  getTouristsDataList: (code) =>
    service.post("/api/bigData/getTouristsDataList", { code }),

  /**
   * 获取行政地区产业规划
   * @param {String} code 行政区划编码
   */
  getImportantBusinessList: (code) =>
    service.post("/api/bigData/getImportantBusinessList", { code }),

  /**
   * 获取行政地区投资方向
   * @param {String} code 行政区划编码
   */
  getInvestmentDirectionList: (code) =>
    service.post("/api/bigData/getInvestmentDirectionList", { code }),

  /**
   * 获取行政地区招商服务
   * @param {String} code 行政区划编码
   */
  getInvestmentServiceList: (code) =>
    service.post("/api/bigData/getInvestmentServiceList", { code }),

  /**
   * 获取行政地区政策支持
   * @param {String} code 行政区划编码
   */
  getPolicySupportList: (code) =>
    service.post("/api/bigData/getPolicySupportList", { code }),

  /**
   * 获取行政地区投资环境
   * @param {String} code 行政区划编码
   */
  getBusinessEnvironmentList: (code) =>
    service.post("/api/bigData/getBusinessEnvironmentList", { code }),

  /**
   * 获取行政地区下级区域数量
   * @param {String} code 行政区划编码
   */
  getNextLevelCount: (code) =>
    service.post("/api/bigData/getNextLevelCount", { code }),

  /**
   * 获取文化遗址数量及各遗址类型列表
   * @param {String} code 行政区划编码
   */
  getYiZhiList: (code) =>
    service.post("/api/bigData/getYiZhiList", {
      code,
    }),

  /**
   * 获取分类
   */
  getProductCategoryList: () =>
    service.post("/api/bigData/getProductCategoryList"),

  /**
   * 推荐商品
   * @param {Object} params.
   * @param {String} params.regionCode 行政区域Id
   * @param {String} params.categoryId 类型Id
   * @param {Array} params.exceptSpuIdsList 已展示的SpuId
   */
  getHotSpu: (params) => service.post("/api/bigData/getHotSpu", params),

  /**
   * 限时优惠
   * @param {*} params
   * @param {*} params.exceptSpuIdsList 已展示的SpuId
   * @returns
   */
  flashSale: (params) => service.post("/api/bigData/flashSale", params),

  /**
   * 商品详情
   * @param {*} spuId
   * @returns
   */
  getProductDetail: (spuId) =>
    service.post("/api/bigData/getProductDetail", { spuId }),

  /**
   * 热门景区
   * @param {Object} params.
   * @param {String} params.regionCode 行政区域Id
   * @param {Array} params.exceptScenicIdsList
   */
  getHotScenic: (params) => service.post("/api/bigData/getHotScenic", params),

  /**
   * 热门菜品
   * @param {Object} params.
   * @param {String} params.regionCode 行政区域Id
   * @param {Array} params.exceptScenicIdsList 
   */
  getHotDish: (params) => service.post("/api/bigData/getHotDish", params),

  /**
   * 热门酒店
   * @param {Object} params.
   * @param {String} params.regionCode 行政区域Id
   * @param {Array} params.exceptScenicIdsList 
   */
  getHotHotel: (params) => service.post("/api/bigData/getHotHotel", params),
};

export const sysWxOpen = {
  /**
   * 生成二维码
   * @param {Object} params.
   * @returns
   */
  generateQRImage: (params) => post("/api/sysWxOpen/generateQRImage", params),
};

export const mall = {
  /**
   *
   * @param {Object} params.
   * @param {Object} params.search. 模糊查询条件
   * @param {Array} params.search.fields 字段名称集合
   * @param {String} params.search.keyword keyword
   * @param {String} params.keyword 模糊查询关键字
   * @param {Number} params.page 当前页码
   * @param {Number} params.pageSize 页码容量
   * @param {String} params.field 排序字段
   * @param {String} params.order 排序方向
   * @param {String} params.descStr 降序排序
   * @param {String} params.keyWords 关键字
   * @param {boolean} params.isHot 是否热门（在首页显示）
   * @param {String} params.regionCode 行政区域编码
   */
  page: (params) =>
    Promise.resolve({
      code: 200,
      type: "success",
      message: "",
      result: {
        page: 1,
        pageSize: 100,
        total: 134,
        totalPages: 2,
        items: [
          {
            spuId: 681354452582469,
            title: "红托竹荪鲜蛋",
            imagePath: "upload/BzSPUImage/ImagePath/681355224117317.jpg",
            saleCount: 1,
            price: 100,
          },
          {
            spuId: 681354607022149,
            title: "红托竹荪鲜货",
            imagePath: "upload/BzSPUImage/ImagePath/681355593764933.png",
            saleCount: 1,
            price: 180,
          },
          {
            spuId: 681354752876613,
            title: "羊肚菌干品礼盒",
            imagePath: "upload/BzSPUImage/ImagePath/681355654340677.png",
            saleCount: 1,
            price: 328,
          },
          {
            spuId: 681354957725765,
            title: "红托竹荪干品礼盒",
            imagePath: "upload/BzSPUImage/ImagePath/681355728801861.png",
            saleCount: 1,
            price: 168,
          },
          {
            spuId: 681355109437509,
            title: "红托竹荪干品礼盒",
            imagePath: "upload/BzSPUImage/ImagePath/681355772145733.png",
            saleCount: 1,
            price: 248,
          },
          {
            spuId: 681587213963333,
            title: "赣之村香菇",
            imagePath: "upload/BzSPUImage/ImagePath/681587511660613.png",
            saleCount: 1,
            price: 49,
          },
          {
            spuId: 681592020852805,
            title: "戈坪乡村土榨山茶油",
            imagePath: "upload/BzSPUImage/ImagePath/681596539560005.png",
            saleCount: 0,
            price: 0,
          },
          {
            spuId: 681595330220101,
            title: "赣之村有机压榨一级500*2山茶油礼盒（初榨原香）（井冈山）",
            imagePath: "upload/BzSPUImage/ImagePath/681595543633989.png",
            saleCount: 1,
            price: 158,
          },
          {
            spuId: 681595884466245,
            title: "赣之村茶树菇",
            imagePath: "upload/BzSPUImage/ImagePath/681597105246277.png",
            saleCount: 1,
            price: 49,
          },

          {
            spuId: 681597911097413,
            title: "赣之村有机压榨一级1L山茶油（初榨原香）（井冈山）",
            imagePath: "upload/BzSPUImage/ImagePath/681597300113477.png",
            saleCount: 1,
            price: 128,
          },
          {
            spuId: 681598534516805,
            title: "赣之村压榨一级山茶油",
            imagePath: "upload/BzSPUImage/ImagePath/681607303905349.png",
            saleCount: 1,
            price: 69,
          },
          {
            spuId: 681599216988229,
            title: "赣之村压榨一级山茶油",
            imagePath: "upload/BzSPUImage/ImagePath/681598679998533.png",
            saleCount: 1,
            price: 148,
          },
          {
            spuId: 681600059093061,
            title: "赣之村核桃油",
            imagePath: "upload/BzSPUImage/ImagePath/681599338393669.png",
            saleCount: 1,
            price: 65,
          },
          {
            spuId: 681600527376453,
            title: "赣之村核桃油",
            imagePath: "upload/BzSPUImage/ImagePath/681600151707717.png",
            saleCount: 1,
            price: 139,
          },
          {
            spuId: 681601259073605,
            title: "赣之村茶油农场（山茶油/橄榄油/核桃油/亚麻籽油255mL各一瓶）",
            imagePath: "upload/BzSPUImage/ImagePath/681600683954245.png",
            saleCount: 1,
            price: 218,
          },
          {
            spuId: 681602279727173,
            title: "秋味坊压榨一级山茶油礼盒（井冈山）",
            imagePath: "upload/BzSPUImage/ImagePath/681601357979717.png",
            saleCount: 1,
            price: 218,
          },
          {
            spuId: 681602884132933,
            title: "赣之村山茶油",
            imagePath: "upload/BzSPUImage/ImagePath/681603029401669.png",
            saleCount: 1,
            price: 208,
          },
          {
            spuId: 681604419919941,
            title: "赣之村山茶油",
            imagePath: "upload/BzSPUImage/ImagePath/681604529299525.png",
            saleCount: 1,
            price: 108,
          },
          {
            spuId: 681605008248901,
            title: "赣之村亚麻籽油",
            imagePath: "upload/BzSPUImage/ImagePath/681605086462021.png",
            saleCount: 1,
            price: 119,
          },
          {
            spuId: 681605620727877,
            title: "赣之村鹿茸菇",
            imagePath: "upload/BzSPUImage/ImagePath/681605692985413.png",
            saleCount: 1,
            price: 49,
          },
          {
            spuId: 681606136688709,
            title: "赣之村木耳",
            imagePath: "upload/BzSPUImage/ImagePath/681606178013253.png",
            saleCount: 1,
            price: 49,
          },
          {
            spuId: 681606137069637,
            title: "赣之村特级初榨橄榄油",
            imagePath: "upload/BzSPUImage/ImagePath/681606223720517.png",
            saleCount: 1,
            price: 108,
          },

          {
            spuId: 681607537070149,
            title: "姬松茸",
            imagePath: "upload/BzSPUImage/ImagePath/681607595171909.jpg",
            saleCount: 1,
            price: 69,
          },
          {
            spuId: 681609249443909,
            title: "戈坪乡村土榨山茶油",
            imagePath: "upload/BzSPUImage/ImagePath/681609340383301.png",
            saleCount: 1,
            price: 680,
          },
          {
            spuId: 681612163334213,
            title: "羊肚菌（特级）",
            imagePath: "upload/BzSPUImage/ImagePath/681612219605061.jpg",
            saleCount: 1,
            price: 188,
          },
          {
            spuId: 681612984385605,
            title: "秋味坊橄榄油",
            imagePath: "upload/BzSPUImage/ImagePath/681613147873349.png",
            saleCount: 1,
            price: 398,
          },
          {
            spuId: 681613537910853,
            title: "赣之村山茶油礼盒",
            imagePath: "upload/BzSPUImage/ImagePath/681613636370501.png",
            saleCount: 1,
            price: 298,
          },
          {
            spuId: 681614823030853,
            title: "赣之村油茶农场",
            imagePath: "upload/BzSPUImage/ImagePath/681614986096709.png",
            saleCount: 1,
            price: 279,
          },
          {
            spuId: 681615606931525,
            title: "赣之村山茶油（铁罐）",
            imagePath: "upload/BzSPUImage/ImagePath/681615822454853.png",
            saleCount: 1,
            price: 69,
          },
          {
            spuId: 681616415096901,
            title: "赣之村山菌四珍（鹿茸菇、茶树菇、木耳、香菇）/礼盒",
            imagePath: "upload/BzSPUImage/ImagePath/681649388265541.png",
            saleCount: 1,
            price: 128,
          },
          {
            spuId: 681616539365445,
            title: " 赣之村 十味菌汤包 （礼盒）",
            imagePath: "upload/BzSPUImage/ImagePath/681649479610437.png",
            saleCount: 1,
            price: 118,
          },
          {
            spuId: 681618813956165,
            title: "秋味坊亚麻籽油",
            imagePath: "upload/BzSPUImage/ImagePath/681618920693829.png",
            saleCount: 1,
            price: 79,
          },
          {
            spuId: 681619615002693,
            title: "赣之村山茶油（铁罐）",
            imagePath: "upload/BzSPUImage/ImagePath/681619933806661.png",
            saleCount: 1,
            price: 128,
          },
          {
            spuId: 681620110831685,
            title: "赣之村 铁皮石斛花 五彩金银花 （礼盒）",
            imagePath: "upload/BzSPUImage/ImagePath/681649676935237.png",
            saleCount: 1,
            price: 108,
          },
          {
            spuId: 681620306579525,
            title: "赣之村山茶油（铁罐）",
            imagePath: "upload/BzSPUImage/ImagePath/681620381966405.png",
            saleCount: 1,
            price: 298,
          },
          {
            spuId: 681620716986437,
            title: "赣之村亚麻籽油",
            imagePath: "upload/BzSPUImage/ImagePath/681620836909125.png",
            saleCount: 1,
            price: 79,
          },
          {
            spuId: 681621168943173,
            title: "秋味坊山茶油（浸出一级）",
            imagePath: "upload/BzSPUImage/ImagePath/681621334175813.png",
            saleCount: 1,
            price: 139,
          },
          {
            spuId: 681629719351365,
            title: "赣之村大国工酱（牛肉酱）",
            imagePath: "upload/BzSPUImage/ImagePath/681643087097925.jpg",
            saleCount: 16,
            price: 15,
          },
          {
            spuId: 681644629278789,
            title: "赣之村大国工酱（鱼仔酱）",
            imagePath: "upload/BzSPUImage/ImagePath/681644880662597.jpg",
            saleCount: 26,
            price: 15,
          },

          {
            spuId: 681646208483397,
            title: "赣之村我是小菜礼盒",
            imagePath: "upload/BzSPUImage/ImagePath/681646273835077.jpg",
            saleCount: 8,
            price: 48,
          },
          {
            spuId: 681647287959621,
            title: "赣之村茶油酵藏萝卜",
            imagePath: "upload/BzSPUImage/ImagePath/681647491756101.png",
            saleCount: 88,
            price: 10,
          },
          {
            spuId: 681648372551749,
            title: "铁皮石斛花",
            imagePath: "upload/BzSPUImage/ImagePath/681649754091589.png",
            saleCount: 1,
            price: 25,
          },
          {
            spuId: 681648498647109,
            title: "五彩金银花",
            imagePath: "upload/BzSPUImage/ImagePath/681649907929157.png",
            saleCount: 1,
            price: 25,
          },
          {
            spuId: 681648618979397,
            title: "菌汤包",
            imagePath: "upload/BzSPUImage/ImagePath/681649991602245.png",
            saleCount: 1,
            price: 21.8,
          },
          {
            spuId: 681648890359877,
            title: "鹿茸菇",
            imagePath: "upload/BzSPUImage/ImagePath/681650096980037.png",
            saleCount: 1,
            price: 26.8,
          },
          {
            spuId: 681649009508421,
            title: "茶树菇",
            imagePath: "upload/BzSPUImage/ImagePath/681650234843205.png",
            saleCount: 1,
            price: 26.8,
          },
          {
            spuId: 681649064927301,
            title: "赣之村茶油初纤芥菜",
            imagePath: "upload/BzSPUImage/ImagePath/681649274482757.png",
            saleCount: 28,
            price: 10,
          },
          {
            spuId: 681649111404613,
            title: "木耳",
            imagePath: "upload/BzSPUImage/ImagePath/681650388070469.png",
            saleCount: 1,
            price: 26.8,
          },
          {
            spuId: 681649212678213,
            title: "香菇",
            imagePath: "upload/BzSPUImage/ImagePath/681650469023813.png",
            saleCount: 1,
            price: 26.8,
          },
          {
            spuId: 681649940996165,
            title: "秋味坊山茶油500*2礼盒（浸出一级）",
            imagePath: "upload/BzSPUImage/ImagePath/681650129039429.png",
            saleCount: 1,
            price: 118,
          },
          {
            spuId: 681650014736453,
            title: "赣之村茶油开坛豇豆",
            imagePath: "upload/BzSPUImage/ImagePath/681650864984133.png",
            saleCount: 90,
            price: 10,
          },
          {
            spuId: 681650599505989,
            title: "赣之村土榨山茶油",
            imagePath: "upload/BzSPUImage/ImagePath/681650694406213.png",
            saleCount: 1,
            price: 39.8,
          },
          {
            spuId: 681651077218373,
            title: "赣之村核桃油（压榨一级）",
            imagePath: "upload/BzSPUImage/ImagePath/681651182485573.png",
            saleCount: 1,
            price: 25.8,
          },
          {
            spuId: 681651518918725,
            title: "赣之村亚麻籽油",
            imagePath: "upload/BzSPUImage/ImagePath/681651654287429.png",
            saleCount: 1,
            price: 12,
          },
          {
            spuId: 681651573375045,
            title: "赣之村每日芥菜（原香味）",
            imagePath: "upload/BzSPUImage/ImagePath/681651903782981.jpg",
            saleCount: 88,
            price: 10,
          },
          {
            spuId: 681652020588613,
            title: "赣之村低芥酸浓香菜籽油（非转基因）",
            imagePath: "upload/BzSPUImage/ImagePath/681652111392837.png",
            saleCount: 1,
            price: 10,
          },
          {
            spuId: 681652455759941,
            title: "赣之村每日芥菜（香辣味）",
            imagePath: "upload/BzSPUImage/ImagePath/681652624121925.jpg",
            saleCount: 26,
            price: 10,
          },
          {
            spuId: 681652806619205,
            title: "赣之村山茶籽调和油",
            imagePath: "upload/BzSPUImage/ImagePath/681652917903429.png",
            saleCount: 1,
            price: 79,
          },
          {
            spuId: 681653281472581,
            title: "赣之村鲜椒牛肉酱",
            imagePath: "upload/BzSPUImage/ImagePath/681653435908165.png",
            saleCount: 28,
            price: 15,
          },
          {
            spuId: 681653340213317,
            title: "赣之村葵花籽调和油",
            imagePath: "upload/BzSPUImage/ImagePath/681653399556165.png",
            saleCount: 1,
            price: 79,
          },
          {
            spuId: 681653734432837,
            title: "赣之村玉米调和油",
            imagePath: "upload/BzSPUImage/ImagePath/681653786456133.png",
            saleCount: 1,
            price: 79,
          },

          {
            spuId: 681654151905349,
            title: "赣之村浓香稻米油",
            imagePath: "upload/BzSPUImage/ImagePath/681654249082949.png",
            saleCount: 1,
            price: 95,
          },

          {
            spuId: 681654564847685,
            title: "青花山水",
            imagePath: "upload/BzSPUImage/ImagePath/681658491859013.jpg",
            saleCount: 10,
            price: 6800,
          },
          {
            spuId: 681654802890821,
            title: "赣之村菜籽油（一级）/非转/低芥酸",
            imagePath: "upload/BzSPUImage/ImagePath/681654902722629.png",
            saleCount: 1,
            price: 95,
          },
          {
            spuId: 681655221022789,
            title: "赣之村压榨一级葵花籽油",
            imagePath: "upload/BzSPUImage/ImagePath/681655363391557.png",
            saleCount: 1,
            price: 89,
          },
          {
            spuId: 681655261388869,
            title: "赣之村南酸枣粒",
            imagePath: "upload/BzSPUImage/ImagePath/681655589613637.png",
            saleCount: 1,
            price: 24.8,
          },
          {
            spuId: 681655391813701,
            title: "赣之村南酸枣糕",
            imagePath: "upload/BzSPUImage/ImagePath/681655651651653.png",
            saleCount: 1,
            price: 24.8,
          },
          {
            spuId: 681655416012869,
            title: "荷韵",
            imagePath: "upload/BzSPUImage/ImagePath/681658739056709.jpg",
            saleCount: 0,
            price: 0,
          },
          {
            spuId: 681655520186437,
            title: "赣之村南酸枣礼盒",
            imagePath: "upload/BzSPUImage/ImagePath/681655771979845.png",
            saleCount: 1,
            price: 59,
          },
          {
            spuId: 681655731703877,
            title: "赣之村菜籽油（二级）",
            imagePath: "upload/BzSPUImage/ImagePath/681655826481221.png",
            saleCount: 1,
            price: 98,
          },
          {
            spuId: 681656137556037,
            title: "赣之村压榨一级花生油",
            imagePath: "upload/BzSPUImage/ImagePath/681656240853061.png",
            saleCount: 1,
            price: 148,
          },
          {
            spuId: 681656444956741,
            title: "赣品正红实惠装糯米酒6瓶/1件",
            imagePath: "upload/BzSPUImage/ImagePath/681658937393221.jpg",
            saleCount: 0,
            price: 0,
          },
          {
            spuId: 681656609792069,
            title: "赣之村压榨一级玉米油",
            imagePath: "upload/BzSPUImage/ImagePath/681656695906373.png",
            saleCount: 1,
            price: 95,
          },
          {
            spuId: 681656832647237,
            title: "赣南板鸭",
            imagePath: "upload/BzSPUImage/ImagePath/681659063914565.jpg",
            saleCount: 0,
            price: 0,
          },
          {
            spuId: 681656989130821,
            title: "山茶橄榄植物调和油",
            imagePath: "upload/BzSPUImage/ImagePath/681657081729093.png",
            saleCount: 1,
            price: 85,
          },
          {
            spuId: 681657158959173,
            title: "赣之村南酸枣糕",
            imagePath: "upload/BzSPUImage/ImagePath/681659463209029.png",
            saleCount: 1,
            price: 10,
          },
          {
            spuId: 681657455476805,
            title: "山茶亚麻植物调和油",
            imagePath: "upload/BzSPUImage/ImagePath/681657603940421.png",
            saleCount: 1,
            price: 85,
          },

          {
            spuId: 681657986637893,
            title: "赣之村亚麻籽油",
            imagePath: "upload/BzSPUImage/ImagePath/681658090582085.png",
            saleCount: 1,
            price: 109,
          },
          {
            spuId: 681658520469573,
            title: "赣之村浓香稻米油",
            imagePath: "upload/BzSPUImage/ImagePath/681658668441669.png",
            saleCount: 1,
            price: 69,
          },
          {
            spuId: 681659137978437,
            title: "赣之村山茶调和油",
            imagePath: "upload/BzSPUImage/ImagePath/681659264249925.png",
            saleCount: 1,
            price: 68,
          },
          {
            spuId: 681659662757957,
            title: "赣之村玉米油",
            imagePath: "upload/BzSPUImage/ImagePath/681659735810117.png",
            saleCount: 1,
            price: 69,
          },
        ],
        hasPrevPage: false,
        hasNextPage: true,
      },
      extras: null,
      time: "2025-05-30 17:06:35",
    }),
  // service.post("/api/mall/page", params),

  /**
   * 商品详情
   * @param {Object} params.
   * @param {Object} params.spuId
   */
  getProductDetail: (params) =>
    service.post("/api/mall/getProductDetail", params),
};



export const common = {
  /**
   * 根据推荐位Id获取推荐位内容
   * @param {*} recommendPlaceId 推荐位Id
   */
  recommendContent: (recommendPlaceId) =>
    service.get("/userApi/common/recommendContent/" + recommendPlaceId),


};